import { create } from 'zustand';

interface ToastState {
  message: string | null;
  kind: 'info' | 'error' | 'success';
  show: (m: string, kind?: ToastState['kind']) => void;
  clear: () => void;
}

export const useToast = create<ToastState>((set) => ({
  message: null,
  kind: 'info',
  show: (message, kind = 'info') => {
    set({ message, kind });
    setTimeout(() => set({ message: null }), 3000);
  },
  clear: () => set({ message: null }),
}));

export function Toaster() {
  const { message, kind } = useToast();
  if (!message) return null;
  const color =
    kind === 'error'
      ? 'bg-red-600'
      : kind === 'success'
        ? 'bg-emerald-600'
        : 'bg-navy';
  return (
    <div
      className={`fixed bottom-5 left-1/2 z-[9999] -translate-x-1/2 rounded-lg ${color} px-4 py-2 text-sm font-semibold text-white shadow-lg`}
    >
      {message}
    </div>
  );
}
